module.exports = __webpack_public_path__ + "assets/icon-file-white.aa209317.svg";